
export default function FilterComponent({
  openFilter,
  setOpenFilter,
  selectedRole,
  userRole,
  setSelectedRole,
}: {
  openFilter: boolean;
  setOpenFilter: any;
  selectedRole: any[];
  userRole:any[];
  setSelectedRole: any;
}) {
  const handleClick = (e: any) => {
    const { name, checked } = e.target;
    if (name === "allSelect") {
      let tempColm = selectedRole.map((column) => {
        return { ...column, isChecked: checked };
      });
      setSelectedRole(tempColm);
    } else {
      let tempColm = selectedRole.map((column) =>
        column.heading === name ? { ...column, isChecked: checked } : column
      );
      setSelectedRole(tempColm);
    }
  };
  return (
    <>
      <>
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div
            className="fixed inset-0 w-full h-full bg-black opacity-40"
            onClick={() => setOpenFilter(false)}
          ></div>
          <div className="flex items-center min-h-screen px-4 py-8">
            <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-lg shadow-lg">
              <div className="mt-3 sm:flex">
                <div className="mb-2 text-center sm:ml-4 sm:text-left">
                  <h4 className="text-lg font-medium text-gray mb-4">
                    Select the User Role to filter data by user role.
                  </h4>

                  <div className=" grid grid-cols-2 gap-3  ">
                    {/* <div className='items-start'>

        <input type="checkbox" value="" name="allSelect" className="w-4  h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" onChange={handleClick}/>
                <label  className="ml-2 uppercase text-sm font-medium text-gray-900 dark:text-gray-300">All Select</label>
          </div> */}
                    {selectedRole.map((column) => {
                      return (
                        <div
                          key={column.heading}
                          className="border rounded border-borderColor p-2"
                        >
                          <input
                            type="checkbox"
                            value=""
                            name={column.heading}
                            defaultChecked={column.isChecked}
                            className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            onClick={handleClick}
                          />
                          <label className="ml-2 capitalize	 text-sm font-sans font-light">
                            {column.heading}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                  <div className="items-center gap-3 mt-3 sm:flex">
                  <button
                    className="w-full bg-lightBlue text-Black active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setOpenFilter(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="w-full bg-recity text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setOpenFilter(false)}
                  >
                    Done
                  </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
}
